// Comanda de uma mesa para o painel (olhinho do cartão em Mesas). Recarrega a
// cada 15 s enquanto a janela está aberta: o KDS muda a situação dos pratos.
import axios from "axios";
import { useCallback, useEffect, useState } from "react";

const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } });

// O servidor manda {codigo, mensagem} ou texto; nunca entregar objeto à tela
const mensagemDe = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (d && typeof d.mensagem === "string") return d.mensagem;
  return "Não foi possível abrir a comanda. Tente de novo.";
};

export function useComandaMesa(mesaId) {
  const [dados, setDados] = useState(null);
  const [erro, setErro] = useState(null);

  const recarregar = useCallback(async () => {
    if (!mesaId) return;
    try {
      const { data } = await axios.get(`/api/mesa-qr/${encodeURIComponent(mesaId)}/comanda`, auth());
      setDados(data);
      setErro(null);
    } catch (e) {
      setErro(mensagemDe(e));
    }
  }, [mesaId]);

  useEffect(() => {
    setDados(null);
    setErro(null);
    if (!mesaId) return undefined;
    recarregar();
    const t = setInterval(recarregar, 15000);
    return () => clearInterval(t);
  }, [mesaId, recarregar]);

  return { dados, erro };
}
